import { Schema } from 'effect';
import { SiteId } from './common.js';
/** DTO schemas for the /www group. See http/payment.ts for conventions. */
export const SiteCreateBody = Schema.Struct({
    siteId: Schema.optional(SiteId),
    siteName: Schema.optional(Schema.String),
    plan: Schema.optional(Schema.String),
    wizardOptions: Schema.optional(Schema.Any),
    // TERMS_VERSION of the terms the owner accepted in the signup
    termsVersion: Schema.optional(Schema.String)
});
export const SiteCreateResponse = Schema.Struct({
    success: Schema.Boolean,
    siteId: Schema.String,
    siteName: Schema.String,
    plan: Schema.String,
    message: Schema.String
});
export const CheckoutBody = Schema.Struct({
    siteId: Schema.optional(SiteId),
    returnUrl: Schema.optional(Schema.String)
});
export const CheckoutResponse = Schema.Struct({
    success: Schema.Boolean,
    // stripeSubscriptionCreateSession can legitimately return null.
    clientSecret: Schema.NullOr(Schema.String),
    publicKey: Schema.String
});
export const StripeConfigResponse = Schema.Struct({ publicKey: Schema.String });
export const StripeReturnBody = Schema.Struct({
    siteId: Schema.optional(SiteId),
    sessionId: Schema.optional(Schema.String)
});
export const SuccessMessageResponse = Schema.Struct({
    success: Schema.Boolean,
    message: Schema.String
});
export const SitesResponse = Schema.Struct({
    success: Schema.Boolean,
    sites: Schema.mutable(Schema.Array(Schema.Any))
});
export const ContactBody = Schema.Struct({
    name: Schema.optional(Schema.String),
    email: Schema.optional(Schema.String),
    message: Schema.optional(Schema.String)
});
export const CustomTokenResponse = Schema.Struct({
    customToken: Schema.String
});
//# sourceMappingURL=www.js.map